module.exports = __webpack_public_path__ + "media/images/kaoawase/top/plan/plan-detail-background-8a8aa03ea9af842129752afda700b4bd.jpg";